module.exports = __webpack_public_path__ + "static/img/9.99700ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/zh/9.png
// module id = /yjX
// module chunks = 0